export default (params) => ({
  trigger: {
    name: 'service_selector.read_explanation',
    params: params,
  },
  config: {
    schema: {
      subject_id: {
        type: 'string',
      },
      sub_feature: {
        enum: [
          'order_block',
          'order_block_summary',
          'configurator',
          'configurator_overlay',
          'shopping_cart',
        ],
      },
    },
    event: {
      name: 'read_explanation',
      params: {
        subject_type: 'item',
      },
    },
  },
});
